export const flipCard = `
.flipcard-text {
  text-align: center;
  
  > div {
  
    ul, ol {
			list-style-position: inside;		
		}

    > ul, > ol { 
      display: inline-block;
      margin-left: 0px;
    }
  }

}

.flipCardFace {
  p, li {
    line-height: 1.2em !important;
  }
}
`;
